var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DatePicker',{staticClass:"resetable",attrs:{"type":"daterange","placeholder":_vm.placeholder,"editable":_vm.editable,"clearable":true,"transfer":_vm.transfer},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})
}
var staticRenderFns = []

export { render, staticRenderFns }